var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgBook = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 16,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.75.25A2.258 2.258 0 0 0 .5 2.5v15.75c0 .75.557 1.5 1.5 1.5h13.5v-1.5H2.75A.74.74 0 0 1 2 17.5a.74.74 0 0 1 .75-.75H15.5v-1.5H2.75A.74.74 0 0 1 2 14.5a.74.74 0 0 1 .75-.75H15.5V.25H2.75Zm0 1.5H14v10.5H2.75c-.264 0-.516.059-.75.14V2.5a.74.74 0 0 1 .75-.75Zm.75 3v1.5h9v-1.5h-9Z",
  fill: "#111"
})));
export default SvgBook;